(() => {
  const clean = (lines) => {
    const result = lines.map((line) => String(line).trim());
    while (result.length && !result.at(-1)) result.pop();
    return result;
  };
  const parse = (text) => {
    const lines = String(text || '').replace(/\r\n/g, '\n').split('\n');
    if (lines[0] === 'Both glasses:') return { mode: 'same', first: lines.slice(1), second: [] };
    const split = lines.indexOf('Glass 2:');
    if (lines[0] === 'Glass 1:' && split > 0) return { mode: 'different', first: lines.slice(1, split), second: lines.slice(split + 1) };
    return { mode: 'same', first: lines, second: [] };
  };
  const format = ({ mode, first, second }, logo = false) => {
    const a = clean(first).join('\n') || (logo ? 'Logo only, no words' : '');
    const b = clean(second).join('\n') || (logo ? 'Logo only, no words' : '');
    if (!a && !b) return '';
    return mode === 'different' ? `Glass 1:\n${a}\nGlass 2:\n${b}` : a ? `Both glasses:\n${a}` : '';
  };
  const valid = (text) => {
    if (!/^(Both glasses:|Glass 1:)\n/.test(text)) return false;
    const state = parse(text);
    return [state.first, ...(state.mode === 'different' ? [state.second] : [])].every((lines) => lines.length <= 4 && lines.some((line) => line.trim()) && lines.every((line) => line.length <= 80 && !['Glass 1:', 'Glass 2:', 'Both glasses:'].includes(line.trim())));
  };
  window.WalWhiskyPair = { parse, format, valid };
})();
